import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components'
import {Headline4} from './../Common';

const Container = styled.div`
    display: flex;
    flex-direction: column;
    margin-right: 0;
    margin-left: auto;
    width: 450px;
    height: 784px;
    
    background: #D9D9D9;
    align-items: center;
    justify-content: center;
    &>img {
        width: 290.029px;
        height: 628.01px;
        flex-shrink: 0;
    }
    box-sizing: border-box;         /* Opera/IE 8+ */
    -webkit-box-sizing: border-box; /* Safari/Chrome, other WebKit */
    -moz-box-sizing: border-box;    /* Firefox, other Gecko */
    @media (min-width: 319px) and (max-width: 767px) {
        width: calc(100vw - 40px);
        margin-right: unset;
        margin-left: unset;
        margin-bottom: 20px;
        margin-top: 20px;
    }
    @media (min-width: 768px) and (max-width: 1025px) {
        min-width: 323px;
        flex-shrink: 1;
        width: unset;
        margin-right: 0px;
         margin-bottom: unset;
        margin-top: 0px;
    }
`;

const Title = styled(Headline4)`
    margin-bottom: 22px;
    color: rgba(40, 40, 40, 0.85);
`;

export default class PreviewBox extends Component{
    static propTypes = {
        title: PropTypes.string,
        children: PropTypes.node
    };

    render(){
        const {title, children} = this.props;
        return <Container>
            <Title>{title}</Title>
            {children}
        </Container>
    }
}